export const STOP_TIMING_EDITOR_DROPDOWN_Z_INDEX = 4
export const STOP_TIMING_STICKY_HEADER_Z_INDEX = STOP_TIMING_EDITOR_DROPDOWN_Z_INDEX + 1
